import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import section6Data from './data/Section6Data'
import '../../index.css'

const Section6 = () => {
  const [hoveredCard, setHoveredCard] = useState(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 990)

  // Update isMobile when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 990)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Hover handlers (desktop only)
  const handleMouseEnter = (id) => {
    if (!isMobile) {
      setHoveredCard(id)
    }
  }

  const handleMouseLeave = () => {
    if (!isMobile) {
      setHoveredCard(null)
    }
  }

  // Toggle card description on mobile
  const handleClick = (id) => {
    setHoveredCard(hoveredCard === id ? null : id)
  }

  // Animate on scroll into view
  const { ref: Section6Ref, inView: Section6InView } = useInView({ triggerOnce: true })

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  return (
    <motion.section
      className="Section6 md:min-h-[1000px] py-20 flex flex-col items-center "
      ref={Section6Ref}
      variants={fadeInUpVariant}
      initial="hidden"
      animate={Section6InView ? 'visible' : 'hidden'}
    >
      <div className="flex flex-col justify-center items-center py-10 ">
        <motion.h2
          className="Section6-title  text-4xl font-bold mb-8 ml-6 text-black"
          variants={fadeInUpVariant}
          transition={{ delay: 0.2 }}
        >
          Our Features
        </motion.h2>

        <motion.div className="features-grid grid grid-cols-3 gap-4 justify-center items-start ml-6">
          {section6Data.map((feature) => {
            const imgSrc = require(`../../assets/images/${feature.imgName}`)

            return (
              <motion.div
                key={feature.id}
                className={`feature-card  bgwh ${feature.gridClass}`}
                variants={fadeInUpVariant}
                transition={{ delay: feature.delay }}
                onMouseEnter={() => handleMouseEnter(feature.id)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleClick(feature.id)}
              >
                <img src={imgSrc} alt={feature.alt} className="feature-icon" />
                <h4>{feature.title}</h4>
                {/* Show description only if hovered (desktop) or toggled (mobile) */}
                {(hoveredCard === feature.id || !isMobile) && (
                  <p className="feature-description">{feature.description}</p>
                )}
              </motion.div>
            )
          })}
        </motion.div>
      </div>
    </motion.section>
  )
}

export default Section6
